import { Stack, Typography } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import z from "zod";
import { TabsComponent } from "@/components/core/tabs-component";
import { TemplateTable } from "@/components/tables/templates";
import { WorkflowsTable } from "@/components/tables/workflows";
import { queryClient } from "@/helpers/tanstack-client";
import { getGetTemplateQueryKey, getTemplate } from "@/models/backend";

const tabs = ["workflow", "templates", "tags"] as const;

const schema = z.object({
  tab: z.enum(tabs).default("workflow"),
  template: z.union([z.uuid(), z.literal("new")]).optional(),
});

export const Route = createFileRoute("/_authenticated/_contained/workflows/")({
  component: RouteComponent,
  validateSearch: schema,
  loaderDeps: ({ search: { tab, template } }) => ({ tab, template }),
  loader: ({ deps: { tab, template } }) => {
    if (tab === "templates" && template) {
      queryClient.ensureQueryData({
        queryFn: (opts) => getTemplate(template, opts),
        queryKey: getGetTemplateQueryKey(template),
      });
    }
  },
});

function RouteComponent() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const tabs_objs: {
    id: (typeof tabs)[number];
    label: string;
    component: JSX.Element;
  }[] = [
    { id: "workflow", label: "Workflows", component: <WorkflowsTable /> },
    { id: "templates", label: "Templates", component: <TemplateTable /> },
  ];
  return (
    <Stack spacing={2}>
      <Typography variant="h3">Workflows</Typography>
      <TabsComponent
        tabs={tabs_objs}
        selectedTab={tabs_objs.findIndex((tab) => tab.id === search.tab)}
        onSelectedTab={(idx) => navigate({ search: { tab: tabs_objs[idx].id } })}
      />
    </Stack>
  );
}
